import { render } from "./ProjectDetailPage.vue?vue&type=template&id=ccb95e4c&scoped=true"
import script from "./ProjectDetailPage.vue?vue&type=script&lang=js"
export * from "./ProjectDetailPage.vue?vue&type=script&lang=js"

import "./ProjectDetailPage.vue?vue&type=style&index=0&id=ccb95e4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccb95e4c"]])

export default __exports__